import React from "react";
import { Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../maintenance/Maintenance.css";

import Component1 from "../service_common_components/component1/Component1";
import Component2 from "../service_common_components/component2/Component2";
import Component3 from "../service_common_components/component3/Component3";

const Car_Wash = () => {
  return (
    <section className="Car_Wash service">
      <Container>
        <h4 className="service_title">Car Wash & Detailing</h4>


        <Component1
          title1="Complete Interior & Exterior"
          title2="Care"
          title3="Keep your vehicle looking its best with our professional Car Wash & Detailing services. We specialize in thorough cleaning and restoration, both inside and out, to maintain your car’s appearance, hygiene, and value. Using high-quality cleaning products, advanced tools, and careful techniques, we remove dirt, grime, and stubborn stains while protecting your car’s paint, upholstery, and surfaces.Our detailing services go beyond a regular wash, offering deep interior cleaning, polishing, waxing, and protection treatments that enhance shine and durability. Whether it’s a routine wash or a complete detailing package, our trained professionals ensure every corner of your vehicle is spotless and well-maintained.With our Car Wash & Detailing services, your car not only looks clean and polished but is also protected against wear and tear, helping it stay in top condition for years to come. "
          imgSrc="/assets/images/services/car_wash.png"
        />


        <Component2
          title="Step-by-Step Detailing Process"
          tips={[
            "Clean wheels and tires using specialized cleaners to remove brake dust and grime.",
            "Gently wash the car using soft mitts and brushes to prevent scratches.",
            "Apply foam or soap to loosen dirt, grime, and road contaminants.",
            "Remove loose dirt and debris from the car’s surface using water spray.",
            "Assess the car’s exterior and interior to identify areas that need special attention."
          ]}
          list={true}
        />


        <Component2
          title="Benefits of Regular Detailing"
          tips={[
            "Regular cleaning prevents rust, stains, and deterioration of materials.",
            "A well-maintained and detailed car retains its value and attracts potential buyers.",
            "Proper care of interior and exterior components reduces wear and tear.",
            "Removes dust, dirt, and allergens from carpets, seats, and upholstery for a healthier environment.",
            "Keeps your car looking clean, shiny, and well-maintained."
          ]}
          list={true}
        />


        <Component3
          title="Maintenance Tips"
          tips={[
            "Proper maintenance is key to keeping your vehicle safe, reliable, and running efficiently. Regularly check essential components such as engine oil, coolant, brake fluid, and tire pressure to prevent unexpected breakdowns and ensure smooth performance. Inspect your tires for wear and rotate them periodically to extend their lifespan and maintain proper traction.",
            "Keep your vehicle clean, both inside and out, to protect the paint and interior surfaces from damage caused by dirt, dust, and moisture. Follow the manufacturer’s recommended service schedule for servicing, part replacements, and inspections, and always address minor issues promptly before they escalate into costly repairs.",
          ]}
          list={true}
        />
      </Container>
    </section>
  );
};

export default Car_Wash;
